import { PROCESS } from "@/data/content";
import { Reveal, SectionHead } from "./Reveal";

export const Process = () => (
  <section id="process" className="py-24 lg:py-36 bg-linen-2" data-testid="process-section">
    <div className="container-x">
      <SectionHead eyebrow="How It Works" title="Three steps. Zero guesswork." />
      <div className="mt-16 grid lg:grid-cols-3 gap-px bg-line border border-line">
        {PROCESS.map((p, i) => (
          <Reveal key={p.n} delay={i * 0.12} className="bg-linen-2 p-8 lg:p-10 relative group" data-testid={`process-step-${i + 1}`}>
            <span className="num-serif text-6xl lg:text-7xl leading-none">{p.n}</span>
            <h3 className="font-serif text-2xl lg:text-3xl text-ink mt-6">{p.title}</h3>
            <p className="mt-4 text-sm md:text-base text-stone leading-relaxed">{p.desc}</p>
            <span className="absolute left-0 bottom-0 h-0.5 w-0 bg-brass transition-[width] duration-700 group-hover:w-full" />
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
